// time.ts — relative-time parsing for comment sorting (port of legacy comment-card.js).
// Returns "minutes ago" so a smaller number = more recent.

export function parseRelativeTime(s: string): number {
  if (s === 'now') return 0;
  const m = /^(\d+)([mhd])$/.exec(s);
  if (!m) return Number.MAX_SAFE_INTEGER;
  const n = parseInt(m[1]!, 10);
  if (m[2] === 'm') return n;
  if (m[2] === 'h') return n * 60;
  if (m[2] === 'd') return n * 60 * 24;
  return Number.MAX_SAFE_INTEGER;
}
